<template>
  <div class="py-4 container-fluid">
    <form ref='editForm' class="needs-validation" novalidate>
      <div class="row">
        <div class="text-right col-lg-12 d-flex justify-content-end">
          <div class="col-lg-1 p-0 text-start">
            <a
              class="p-0 back-button"
              style="cursor: pointer"
              :title="$t('key_button_back')"
              @click="$router.go(-1)">
              <i class="fa fa-arrow-circle-left" style="font-size: 35px;"></i>
            </a>
          </div>
          <div class="my-auto ms-auto">
            <button type="button" class="mt-2 mb-0 btn bg-gradient-success ms-lg-auto me-lg-0 me-auto mt-lg-0 " @click="save()">
              {{ $t('key_button_save') }}
            </button>     
          </div>  
        </div>
      </div>
      <ImageExpanded ref="imageExpanded" :image-path="product.image" />
      <div class="mt-4 row">
        <div class="col-lg-3">
          <div class="card cardimage h-100">
            <div class="card-body">
              <div class="row">
                <div class="col-12 text-center" @click="$refs.imageExpanded.expandImage()">
                  <img v-show="product"
                  class="shadow-lg w-80 border-radius-lg product-image picture-cursor"  style="height: 12rem"
                  :class="!product.image? 'noimageColorEdit': ''"
                    :src="!product.image? noimage: product.image"
                    :alt="$t('key_products_image')" />
                </div>
                <div class="mt-4 col-12">
                  <div class="d-flex">
                    <input v-model="product.image" class="form-control" type="text" maxLength="250" :placeholder="$t('key_placeholder_product_image_url')">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-9 mt-lg-0">
          <div class="row">
            <div class="col-lg-6">
              <div class="card cardimage h-100">
                <div class="card-body">
                  <h5 class="font-weight-bolder">{{ $t('key_title_product') }}</h5>
                  <div class="row">
                    <div class="col-12 col-sm-6">
                      <label class="text-primary">{{ $t('key_title_code_name') }} <span style="color:red">*</span> </label>
                      <input v-model="product.name" class="form-control" type="text" :disabled="productId" :placeholder="$t('key_placeholder_code_name')" maxLength="50" required/>
                    </div>
                    <div class="mt-3 col-12 col-sm-6 mt-sm-0">
                      <label class="text-primary">{{ $t('key_title_manufacture_country') }} <span style="color:red">*</span> </label>
                      <hk-select v-model="product.made_in" :placeholder="$t('key_placeholder_manufacture_country')" :options="paisesOptions"> </hk-select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="mt-3 col-12 col-sm-6 mt-sm-0">
                      <label class="text-primary">{{ $t('key_title_tariff_code') }} 
                        <span class="mx-3" style="cursor:pointer" :title="$t('key_description_tariff_code')">
                          <i class="fas fa-question-circle text-secondary"></i>
                        </span>
                      </label>
                      <input v-model="product.hs" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_tariff_code')" />
                    </div>
                    <div class="mt-3 col-12 col-sm-6 mt-sm-0">
                      <label class="text-primary">{{ $t('key_title_supplier') }}</label>
                      <input v-model="product.supplier" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_supplier')" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <label class="text-primary">{{ $t('key_title_description') }} <span style="color:red">*</span> </label> 
                      <input id="controlDesc" v-model="product.description" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_description')" required/>                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="card cardimage">
                  <div class="card-body">
                    <div class="row">
                      <h5 class="font-weight-bolder">{{ $t('key_title_attributes') }}</h5>
                      <div class="row">
                        <div class="col-sm-6">
                          <label class="text-primary" for="controlTemporada">{{ $t('key_title_season') }} <span style="color:red">*</span> </label>
                          <input id="controlTemporada" v-model="product.season" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_season')" required/>                        
                        </div>
                        <div class="col-sm-6">
                          <label class="text-primary">{{ $t('key_title_line') }} <span style="color:red">*</span> <span class="mx-3 " style="cursor:pointer"
                            :title="$t('key_description_line')">
                            <i class="fas fa-question-circle text-secondary"></i>
                          </span> </label>
                          <input v-model="product.line" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_line')" required/>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-6">
                          <label class="text-primary">{{ $t('key_title_family') }} <span style="color:red">*</span> </label>
                          <input v-model="product.family" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_family')" required/>
                        </div>
                        <div class="col-sm-6">
                          <label class="text-primary">{{ $t('key_title_sub_family') }} <span style="color:red">*</span> </label>
                          <input v-model="product.subfamily" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_sub_family')" required/>
                        </div>                    
                      </div>             
                      <div class="row">
                        <div class="col-12">
                          <label class="text-primary">{{ $t('key_title_composition') }}</label>
                          <input id="choices-composicion-edit" class="form-control" type="text" :placeholder="$t('key_placeholder_composition')">
                        </div>
                      </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-sm-4 pt-1 mb-1">
                          <div class="form-check">
                            <input v-model="product.batch_control" class="form-check-input" type="checkbox">
                            <label class="text-primary">
                              {{ $t('key_title_batch_control') }}
                            </label>
                          </div>
                        </div>
                          <!-- MNS <div v-if="product.batch_control" class="col-12 col-sm-4 pt-1 mb-1"> -->
                          <div class="col-12 col-sm-4 pt-1 mb-1">
                            <div class="form-check">
                            <input v-model="product.batch_control_date" class="form-check-input" type="checkbox">
                            <label class="form-label text-primary">{{ $t('key_title_batch_control_date') }}</label>
                              </div>
                          </div>
                      </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </form>
    <div class="mt-4 row">
      <variants :variants=product.variants @variant-added="addVariant" @variant-updated="updatedVariant"></variants>
    </div>
    <div class="position-fixed top-8 end-2 z-index-2">
      <soft-snackbar
        :show="showNotification"
        :title="notificationInfo.title"
        :description="notificationInfo.message"
        :icon="{ component: notificationInfo.status=='success'?'ni ni-check-bold':'ni ni-fat-remove' , color: notificationInfo.status=='success'?'success':'danger' }"
        :color="notificationInfo.status=='success'?'success':'danger'"
        @close-handler="showNotification = !showNotification"
      />
    </div>
  </div>
</template>

<script>
import setTooltip from "@/assets/js/tooltip.js";
import Choices from "choices.js";
import Variants from "./components/Variants";
import HkSelect from "@/hotaka/components/HkSelect.vue";
import { ImageExpanded } from "@/hotaka/components";
import SoftSnackbar from "@/components/SoftSnackbar.vue";
import noimage from  "@/assets/img/sevica-images/noimage.png";
export default {
  name: "EditProduct",
  components: {Variants, HkSelect, SoftSnackbar, ImageExpanded},
  data() {
    return {
      product: {
        made_in: '',
        image: null,
        variants: []
      },
      configDate: {
        allowInput: true,
      },
      paisesOptions:[],
      choicesComposition: null,
      productId: null,
      notificationInfo:{
        title: '',
        message: '',
        status: 'danger'
      },
      showNotification: false,
      noimage,
      imageExpanded: false
    }
  },
  computed: {
    productData() {
      return this.$store.state.products.product.data;
    },
    paises(){
      return this.$store.state.paises.list.data;
    },
    nuevoStatus(){
      return this.$store.state.products.newProduct.data
    },
    editStatus(){
      return this.$store.state.products.updateProduct.data
    },
    batch_control(){
      return this.product.batch_control;
    },
  },
  watch:{
    productData(val) {
      if(val){
        this.product=this.$store.state.products.product.data;
        this.choicesComposition.setValue(this.product.composition)
      }
    },
    paises(values){
      if(values) {
        let elements=[];
        for (let pais of values.items){
          elements.push({
            value: pais.code,
            label:pais.name
          })
        }
        this.paisesOptions = elements.sort((a, b) => a.label.localeCompare(b.label));
      }
    },
    nuevoStatus(newValue){
      if (newValue) {
        this.loadStatusNotification(newValue)
      }
      else if (this.$store.state.products.newProduct.error) {
        this.notificationInfo = {
          title: this.$t('key_mheader_product_error'),
          message: this.$t('key_mmessage_product_saving_error'),
          status: 'error'
        }
        this.showNotification = true;
        this.closeNotification();
      }
    },
    editStatus(newValue){
      if (newValue) {
        this.loadStatusNotification(newValue)
      } else if (this.$store.state.products.updateProduct.error) {
        this.notificationInfo = {
          title: this.$t('key_mheader_product_error'),
          message: this.$t('key_mheader_product_updating_error'),
          status: 'error'
        }
        this.showNotification = true;
        this.closeNotification();
      }
    },
    /* batch_control(newValue){
      if (newValue==false){
        this.product.batch_control_date=false;
      }
    } */
  },
  mounted() {
    this.getPaises();
    this.productId=this.$route.params.id;
    if(this.productId){
      this.$store.commit("products/getById",this.$route.params.id);
    }
    if (document.getElementById("choices-composicion-edit")) {
      var composicion = document.getElementById("choices-composicion-edit");
      this.choicesComposition = new Choices(composicion, {
        removeItemButton: true,
      });
    }
    setTooltip(this.$store.state.bootstrap);
  },
  methods: {
    getPaises(){
      this.$store.commit("paises/load");
    },
    edit(index) {
      if (index!=this.variantSelected.index || this.variantSelected.disabled==false)
        return true;
      else 
        return false;
    },
    updatedVariant(value){
      for (let i=0; i<this.product.variants.lenght; i++){
        if (this.product.variants[i].ean== value.ean){ 
          this.product.variants[i]=value;
        }
      }
    },
    addVariant(val){
      this.product.variants.push(val);
    },
    save(){
      let form= this.$refs.editForm;
      if (form.checkValidity()) {
        if(this.product.variants.length==0){
          this.notificationInfo = {
          title: this.$t('key_mheader_product_variant_warning'),
          message: this.$t('key_mmessage_product_variant_warning'),
          status: 'error'
        }
        this.showNotification = true;
        this.closeNotification();
        return
        }
        this.product.composition= this.choicesComposition.getValue(true);
        if(!this.productId || this.productId==''){
          this.$store.commit("products/newProduct",this.product);
        }
        else{
          this.$store.commit("products/updateProduct",this.product);
        }
      }
      form.classList.add('was-validated')
    },
    closeNotificationAndRedirect(){
      const self= this;
      setTimeout(function () {
          self.$router.push({ name: "Products list"});
      }, 1050);
    },
    closeNotification(){
      const self= this;
      setTimeout(function () {
          self.showNotification=false
      },1300);
    },
    loadStatusNotification(value){
        if (value.status == 'KO') {
          this.notificationInfo = {
            title: this.$t('key_mheader_product_error'),
            message: value.data.error,
            status: 'error'
          }
          this.showNotification = true;
          this.closeNotification();
        } else {
          this.notificationInfo = {
            title: this.$t('key_mheader_product_ok'),
            message: this.$t('key_mmessage_product_ok'),
            status: 'success'
          }
          this.showNotification = true;
          this.closeNotificationAndRedirect();
        }
    },
  },
};
</script>

<style lang="scss" scoped>

.noimageColorEdit{ 
  opacity: 0.1 !important;  
}

.picture-cursor {
  cursor: url('../../assets/img/zoom-in.svg'), auto;
}

.cardimage {
  position: inherit !important;
}

.form-control:disabled{
  background-color: white;
  border: 1px solid transparent;
}

.noimageColor{ 
  opacity: 0.1 !important;
}

.back-button {
  color: #4A7062
}

.product-image {
  object-fit: contain;
  transition: transform .2s;
  border-radius: 10px;
  transition: all 0.2s ease-in-out;
  border-radius: 6px;
}
</style>

 